import { RECEIVE_TRAINING_VIDEOS_DATA } from "../actions/trainingVideosActions";

const initialState = {};

export default function trainingVideosReducer(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_TRAINING_VIDEOS_DATA:
      return {
        ...state,
        trainingVideos: [...action.payload]
      };
    default:
      return state
  }
};



// WEBPACK FOOTER //
// ./src/reducers/trainingVideosReducer.js